<template>
  <Loading
    v-if="composable.loading.setting.isShow"
    :content="composable.loading.setting.content"
  />

  <div
    v-if="page === 'initialization'"
    class="page"
  />
  <div
    v-else-if="page === 'queryForm'"
    class="page"
  >
    <Header
      :setting="{
        title: '超音波影像',
        hasCancelMethod: false,
      }"
      class="mb4"
    />
    <div class="page__form mv8">
      <input
        v-model="queryForm.patientNumber"
        type="text"
        placeholder="身份證/Resident ID No."
        class="mb5"
      >
    </div>
    <div
      @click="query"
      class="label label--primary mb4"
    >
      查詢
    </div>
  </div>

  <div
    v-else-if="page==='albums'"
    class="page"
  >
    <Header
      :setting="{
        title: '超音波影像',
        hasCancelMethod: false,
      }"
      class="mb4"
    />

    <div v-if="albums.length ===0">
      查無超音波影像
    </div>
    <div
      v-if="composable.member.os==='ios'"
      class="page__text ba--primary border-radius-1 pv3 ph2 mb4 align--left"
    >
      溫馨提醒：<br>
      <span class="fw4">
        ＊系統測試中，目前僅提供高層次超音波影像下載。 <br>
        ＊iOS 14.4 超音波影像無法正常運作，煩請更新作業系統。
      </span>
    </div>
    <div
      v-else-if="composable.member.os==='android'"
      class="page__text ba--primary border-radius-1 pv3 ph2 mb4 align--left"
    >
      溫馨提醒：<br>
      <span class="fw4">
        ＊系統測試中，目前僅提供高層次超音波影像下載。 <br>
      </span>
    </div>
    <div class="row--auto-fill-2">
      <div
        v-for="anAlbum in albums"
        :key="anAlbum"
        @click="chooseAlbum(anAlbum)"
        class="bc--secondary border-radius-1 fc--primary mh2 mb4"
      >
        <img
          v-if="anAlbum.photos.length!==0"
          :src="anAlbum.photos[0]"
          alt=""
          class="border-radius-1"
        >
        <video
          v-else
          autoplay
          muted
          playsinline
          class="border-radius-1"
        >
          <source
            :src="anAlbum.videos[0]"
            type="video/mp4"
          >
          Your browser does not support this video file.
        </video>

        <div class="pv1">
          {{ spiderman.moment(anAlbum.date).format('YYYY/MM/DD') }}
        </div>
        <div class="p1 row--evenly">
          <div class="row--central">
            <font-awesome-icon :icon="['fas', 'image']" />
          </div>
          <div>{{ anAlbum.photos.length }}</div>
          <div class="row--central">
            <font-awesome-icon :icon="['fas', 'video']" />
          </div>
          <div>{{ anAlbum.videos.length }}</div>
        </div>
      </div>
    </div>
  </div>

  <Album
    v-else-if="page==='album'"
    :album="album"
    @chooseImage="chooseImage"
    @cancel="page='albums'"
  />

  <Detail
    v-else-if="page==='detail'"
    :image="image"
    @shareImage="shareImage"
    @cancel="page='album'"
  />

  <Death
    v-else
    :message="composable.death.message"
    :page="page"
  />

  <Modal
    v-if="composable.modal.setting.isShow"
    :setting="composable.modal.setting"
    @close="composable.modal.close"
  />
</template>

<script>
import { reactive, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import composable from '@/composable/index';
import spiderman from '@/spiderman/index';
import api from '@/api/index';
import Album from './pages/Album.vue';
import Detail from './pages/Detail.vue';

export default {
  components: { Album, Detail },
  setup() {
    const page = ref('initialization');
    const queryForm = reactive({
      patientNumber: '',
    });
    const albums = ref([]);
    const album = ref(null);
    const image = reactive({
      type: '',
      url: '',
    });
    const route = useRoute();
    const router = useRouter();

    onMounted(async () => {
      try {
        //! 這裡先寫死帶入璟馨patient number, 未來如果詠馨也要用Hibaby, 再寫判斷yungPatientNumber.
        queryForm.patientNumber = composable.member.info.chingPatientNumber;

        if (queryForm.patientNumber === '0075813') {
          page.value = 'queryForm';
          return;
        }

        composable.loading.show('查詢中，請稍候');

        albums.value = await api.hibaby.get(
          composable.member, queryForm,
        );

        page.value = 'albums';
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    });

    async function query() {
      try {
        composable.loading.show('查詢中，請稍候');

        albums.value = await api.hibaby.get(
          composable.member, queryForm,
        );

        // console.log('albums.value=', albums.value);
        page.value = 'albums';
      } catch (error) {
        composable.modal.alert(error);
      } finally {
        composable.loading.close();
      }
    }

    function chooseAlbum(anAlbum) {
      album.value = anAlbum;
      page.value = 'album';
    }

    function chooseImage({ type, url }) {
      image.type = type;
      image.url = url;
      page.value = 'detail';
    }

    function shareImage(anImage) {
      const cmd = spiderman.generate.specialCommand({
        cmd: 'share',
        url: anImage.url,
        type: anImage.type === 'photo' ? 'jpg' : 'mp4',
        timestamp: spiderman.generate.timestamp(),
      });
      const toPath = `${route.path}#inncom#${cmd}`;

      if (route.fullPath !== toPath) router.replace(toPath);
      else router.replace(`${toPath}#`);
    }

    return {
      composable,
      spiderman,
      page,
      queryForm,
      query,
      albums,
      chooseAlbum,
      album,
      chooseImage,
      image,
      shareImage,
    };
  },
};
</script>
